import axios from '../plugins/axios'
import querystring from 'querystring'
import sitesInfo from "@/js/helper/sites-info";

export default {
    loadPackageInfo(goodsId) {
        let params = {
            'id': goodsId,
            'with[]' : [
                'goods_term_prices',
                'application_rule',
                'clause_composition',
                'goods_composition',
                'package',
                'resource_limit_groups',
            ],
        }
        let goodsApiQueryString = querystring.stringify(params);
        const url = sitesInfo.goodsApi + `/openapi/page/application/type/package?` + goodsApiQueryString

        return axios.get(url, {
            headers: {
                Authorization: `GIAK ${process.env.VUE_APP_GOODS_API_KEY}`
            }
        });
    }
}